module.exports = __webpack_public_path__ + "img/banner_arm.1a1c7022.png";